(function () {
  var root = document.querySelector('[data-npop]');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var dialog = $('[data-npop-dialog]'), form = $('#NpopForm');
  var emailEl = $('[data-npop-email]'), consentEl = $('[data-npop-consent]'), errorEl = $('[data-npop-error]'), submitBtn = $('[data-npop-submit]');
  var steps = { form: $('[data-npop-step="form"]'), done: $('[data-npop-step="done"]') };
  var KEY = 'mocksy-npop', WEEK = 7 * 24 * 3600 * 1000;

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function show(step) { Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== step; }); }
  function setError(msg) { errorEl.textContent = msg; errorEl.hidden = !msg; }
  function open() { if (dialog.open) return; if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', ''); }
  function dismiss() { if (get(KEY) !== 'subscribed') set(KEY, String(Date.now())); }
  function close() { dismiss(); if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); }

  root.querySelectorAll('[data-npop-close]').forEach(function (b) { b.addEventListener('click', close); });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
  dialog.addEventListener('cancel', dismiss);

  form.addEventListener('submit', function (e) {
    e.preventDefault(); setError('');
    var email = emailEl.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { setError('Bitte gib eine gültige E-Mail-Adresse ein.'); emailEl.focus(); return; }
    if (!consentEl.checked) { setError('Bitte bestätige die Newsletter-Anmeldung.'); consentEl.focus(); return; }
    submitBtn.disabled = true;
    fetch('/contact', { method: 'POST', body: new FormData(form), credentials: 'same-origin' }).then(function (res) {
      if (res.url && res.url.indexOf('/challenge') > -1) { set(KEY, 'subscribed'); form.submit(); return; } // Bot-Prüfung von Shopify
      if (res.url && res.url.indexOf('customer_posted=true') > -1) { set(KEY, 'subscribed'); show('done'); return; }
      submitBtn.disabled = false;
      setError('Das hat nicht geklappt. Bitte prüfe deine E-Mail-Adresse oder versuche es später nochmals.');
    }).catch(function () {
      submitBtn.disabled = false;
      setError('Keine Verbindung. Bitte versuche es nochmals.');
    });
  });

  // Nach Rückkehr von der Bot-Prüfung die Bestätigung zeigen
  if (get(KEY) === 'subscribed' && /customer_posted=true/.test(location.search)) { open(); show('done'); return; }

  var seen = get(KEY);
  if (seen === 'subscribed') return;
  if (seen && Date.now() - parseInt(seen, 10) < WEEK) return;
  if (root.dataset.auto !== 'true') return;
  var delay = Math.max(3, parseInt(root.dataset.delay, 10) || 10) * 1000;
  window.setTimeout(function () { if (!document.querySelector('dialog[open]')) open(); }, delay);
})();
